// ------------------- utilities ------------------- //
const isBoolean = (candidate)=>candidate !== null && typeof candidate === 'boolean';
const isCapabilityObject = (candidate)=>{
    return candidate !== null && typeof candidate === 'object' && `value` in candidate;
};
const capabilityValue = (capability, defaultVal = false)=>{
    if (isBoolean(capability)) {
        return capability;
    }
    if (isCapabilityObject(capability)) {
        return capability.value;
    }
    return false;
};
const conditionalCapabilityValue = (capability, every, some)=>{
    var _ref, _ref1;
    const isEverySatisfied = (_ref = every === null || every === void 0 ? void 0 : every.every((element)=>capabilityValue(element) === true)) !== null && _ref !== void 0 ? _ref : true;
    const isSomeSatisfied = (_ref1 = some === null || some === void 0 ? void 0 : some.some((element)=>capabilityValue(element) === true)) !== null && _ref1 !== void 0 ? _ref1 : true;
    const capabilityObjValue = capabilityValue(capability);
    return isEverySatisfied && isSomeSatisfied && capabilityObjValue;
};
const getStrings = (capability, stringBundle = {}, fallback = 'This feature is not available.')=>{
    if (isCapabilityObject(capability)) {
        const strings = capability.reasons.map((reason)=>{
            return stringBundle[reason];
        }).filter(Boolean);
        if ((strings === null || strings === void 0 ? void 0 : strings.length) > 0) {
            return strings;
        }
    }
    return fallback;
};
const enabledCapability = {
    on: {
        value: true,
        reasons: []
    },
    actionable: {
        value: true,
        reasons: []
    }
};
const disabledCapability = {
    on: {
        value: false,
        reasons: []
    },
    actionable: {
        value: false,
        reasons: []
    }
};

var conditionalUtilities = /*#__PURE__*/Object.freeze({
  __proto__: null,
  capabilityValue: capabilityValue,
  conditionalCapabilityValue: conditionalCapabilityValue,
  disabledCapability: disabledCapability,
  enabledCapability: enabledCapability,
  getStrings: getStrings,
  isBoolean: isBoolean,
  isCapabilityObject: isCapabilityObject
});

export { conditionalUtilities as a, conditionalCapabilityValue as b, capabilityValue as c, disabledCapability as d, enabledCapability as e, isCapabilityObject as f, getStrings as g, isBoolean as i };
//# sourceMappingURL=conditional-0YSA_RAK.mjs.map
